import { render, staticRenderFns } from "./PostItem.vue?vue&type=template&id=10d8ecec&scoped=true"
import script from "./PostItem.vue?vue&type=script&lang=js"
export * from "./PostItem.vue?vue&type=script&lang=js"
import style0 from "./PostItem.vue?vue&type=style&index=0&id=10d8ecec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d8ecec",
  null
  
)

export default component.exports